import PropTypes from 'prop-types';
import React from 'react';

import styles from './auto-judgement-save-btn.css';

const AutoJudgementSaveBtn = props => (
    <div
        className={styles.autoJudgementSaveBtn}
        onClick={props.onClick}
    >
        <span>
            {props.text}
        </span>
    </div>
);

AutoJudgementSaveBtn.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.strgin
};

export default AutoJudgementSaveBtn;
